import React, { useEffect, useState } from "react";
import Layout from "../Layout/Content";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/auth";
import { toast } from "react-toastify";
import axios from "axios";
import { ethers } from "ethers";
import Loading from "../LoaderPageSection/Loading";
import { contractABI, contractAddress, nefiPro, nefiProABI, nefiStaking, nefiStakingABI, nefiToken, nefiTokenABI } from "../Abi/Content";
const Content = () => {
  const [auth, setAuth] = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [refferalAddress, setRefferalAddress] = useState("");
  const [userAddress, setUserAddress] = useState("");
  // const networkId = 137  //mainnet
  const networkId = 56  //testnet
       //    /*Switch to mainnet*/  const networkData = [
       //         {
       //             chainId: ethers.utils.hexlify(networkId),
       //             rpcUrls: ["https://polygon-rpc.com"],

       //             chainName: "Polygon Mainnet",
       //             nativeCurrency: {
       //                 name: "MATIC",
       //                 symbol: "MATIC", // 2-6 characters long
       //                 decimals: 18,
       //             },
       //             blockExplorerUrls: ["https://polygonscan.com/"],
       //         },
       //     ]
           /*Switch to Testnet*/  const networkData = [
    {
      chainId: networkId,
      rpcUrls: ["https://bsc-dataseed.binance.org/"],

      chainName: "BNB Smart Chain",
      nativeCurrency: {
        name: "BNB",
        symbol: "BNB", // 2-6 characters long
        decimals: 18,
      },
      blockExplorerUrls: ["https:/https://bscscan.com/"],
    },
  ]
  const switchNetworks = async () => {

    try {
      await window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: ethers.utils.hexlify(networkId) }],
      });
    } catch (switchError) {
      // This error code indicates that the chain has not been added to MetaMask.
      if (switchError.code === 4902) {
        try {
          await window.ethereum.request({
            method: 'wallet_addEthereumChain',
            params: networkData
          });
        } catch (addError) {
          // handle "add" error
        }
      }
      // handle other "switch" errors
    }

  }
  const start_and_end = (address) => {
    if (address !== undefined) {
      return (
        address.substr(0, 15) +
        "...." +
        address.substr(address.length - 15, address.length)
      );
    }
    return address;
  };
  const registerNefi = async (referrer) => {
    try {

      const provider = new ethers.providers.Web3Provider(window.ethereum)
      const signer1 = provider.getSigner();
      const account = await signer1.getAddress()
      const network = await provider.getNetwork()
      console.log(network)
      if (network.chainId !== networkId) {
        await switchNetworks()
      }
      const newProvider = new ethers.providers.Web3Provider(window?.ethereum);
      const signer = newProvider.getSigner();
      const nefiContract = new ethers.Contract(nefiPro, nefiProABI, signer)
      const register = await nefiContract.register(referrer)
      const reciept = await register.wait()
      console.log(reciept)
      return reciept
    } catch (error) {
      console.log(error)
      toast.error("Transaction Rejected")
      return error
    }
  }
  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const reciept = await registerNefi(refferalAddress)
      const resp = await axios.post(`https://nefi.onrender.com/api/v1/user/registerUser`, {
        accountAddress: userAddress,
        sponserAddress: refferalAddress,
        transactionHash: reciept.transactionHash
      });
      if (reciept.status === 1) {

        if (resp.status === 201) {
          if (resp?.data?.status === true) {
            toast.success(resp?.data?.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
            setAuth({
              ...auth,
              user: null,
            });
            sessionStorage.removeItem("auth");
            navigate("/");
          } else {
            toast.error("Error", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        } else {
          toast.error("Error", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      }


    } catch (error) {
      if (error?.response?.status === 400) {
        setAuth({
          ...auth,
          user: null,
        });
        sessionStorage.removeItem("auth");
        navigate("/");
        var err_400 = error?.response?.data?.message;
        toast.error(err_400);
      } else if (error.response.status === 401) {
        const err_401 = error?.response?.data?.message;
        toast.error(err_401);
      } else if (error.response.status === 404) {
        const err_404 = error?.response?.data?.message;
        toast.error(err_404);
      } else if (error.response.status === 500) {
        const err_500 = error?.response?.data?.message;
        toast.error(err_500);
      } else {
        console.log("Error in Register", error);
        toast.error("something went wrong");
      }
    }
    setLoading(false);
  };
  const handleRegisterPro = async (e) => {
    e.preventDefault();
    // debugger

    try {
      if (userAddress.toLocaleLowerCase() == refferalAddress.toLocaleLowerCase()) {
        alert('Connected Wallet is Same as Referral , Please change the referrer')
        return
      }
      setLoading(true);
      const provider = new ethers.providers.Web3Provider(window.ethereum)
      const signer = provider.getSigner();
      const account = await signer.getAddress()
      const contract = new ethers.Contract(nefiStaking, nefiStakingABI, signer)
      const trx = await contract.registerReferral(refferalAddress)
      const rcpt = await trx.wait()
       if (rcpt.status === 1) {
      alert('User Registered Successfully ! Please Login ')
          navigate("/");
      }
      // if (rcpt.status === 1) {
      //   const resp = await axios.post(`https://nefi.onrender.com/api/v1/user/registerUser`, {
      //     accountAddress: userAddress,
      //     sponserAddress: refferalAddress,
      //     // transactionHash:reciept.transactionHash
      //   });
      //   if (resp.status == 200) {

      //     alert('User Registered Successfully ! Please Login ')
      //     navigate("/");
      //   }
      // }
    } catch (error) {
      alert("An error occured while registering referral")
    }
    setLoading(false);
  };

  // const handleRegisterPro = () => {
  //   alert("Server under maintenence ! Please Try again later")
  // }
  const getRegisterData = async () => {
    try {
      debugger
      const provider = new ethers.providers.Web3Provider(window.ethereum)
      const signer1 = provider.getSigner();
      const account = await signer1.getAddress()
      const defaultRefferalAddress = ("0x0605E6A1eead9aC175879a5757Eba687DF5ee6a4").toLowerCase();
      // const defaultRefferalAddress = ("0xDD8703720aB03bf0738037a2d4F84b3bECf353Fb").toLowerCase();
      const refferal = sessionStorage.getItem('referral');
      console.log(refferal)
      let isCheckAddress = defaultRefferalAddress
      if (refferal!==null) {
      const contract = new ethers.Contract(nefiStaking, nefiStakingABI, signer1)
      try {
        const result = await contract.stakes(refferal, 0)
       
        isCheckAddress = refferal
       

      } catch (error) {
        alert('Invalid referral link , Using Default Address')
        isCheckAddress = defaultRefferalAddress
      }  
      }
      // isCheckAddress = refferal == null ? defaultRefferalAddress : refferal;
      setUserAddress(account);
      setRefferalAddress(isCheckAddress);
    } catch (error) {
console.log(error)
    }
  }
  useEffect(() => {
    getRegisterData()
  }, []);

  return (
    <Layout title={"Landing page"}>
      <div className="home-bg">
        {loading && <Loading loading={loading} />}
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="allotment-box">
                <form onSubmit={handleRegisterPro}>
                  {/* <form> */}
                  <div className="row">
                    <div className="col-12">
                      <h4
                        className="text-light float-end cus-cancelbtn"
                        onClick={() => navigate("/")}
                      >
                        X
                      </h4>
                    </div>
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label cus-label">
                          Connected Wallet
                        </label>
                        <input
                          type="text"
                          className="form-control cus-control-form"
                          value={userAddress && start_and_end(userAddress)}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label cus-label">
                          Referral Wallet
                        </label>
                        <input
                          type="text"
                          className="form-control cus-control-form"
                          value={refferalAddress && start_and_end(refferalAddress)}
                          disabled
                        />
                      </div>
                      {refferalAddress ===
                        ("0x0605E6A1eead9aC175879a5757Eba687DF5ee6a4").toLowerCase() && (
                          <span className="text-warning">
                            As your account is not referred by any user , You will
                            be registered with default referral address.
                          </span>
                        )}
                    </div>
                  </div>
                  <div className="text-center">
                    <button type="submit" className="btn connect-btn my-3">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Content;
